import React, { useContext, useState } from 'react'
import LogoTranscash from '../../assets/carteTranscashRounded.png'
import classNames from 'classnames'
import CartePrepayeeContext from 'contexts/catrePrepayeeContext'
import imageBgRecharge from '../../assets/imageBgRecharge.svg'
import LogoPCS from '../../assets/logoCartePCSRounded.png'
import { useNavigate } from 'react-router-dom'


interface Props {
    isOpen: boolean
    closeModal: () => void
     successPayment: string
    // isInvoices?: boolean
    // isAssurance?: boolean
    voucher?:string
  }

  const SuccessPaymentCarteModal: React.FC<Props> = ({ isOpen, closeModal, successPayment, voucher }) => {

    const {carte} = useContext(CartePrepayeeContext)
    const[isCopie, setIsCopie]= useState(false)
    const[currentColor, setCurrentColor]=useState('#5754E5')
  const navigate = useNavigate()

    const handleClick=()=>{
      closeModal()
      navigate('/history?activeText=4')   
    }
    const handleCopy=(code: string)=>{
      navigator.clipboard.writeText(code)
      setIsCopie(true)
      setTimeout(() => setIsCopie(false), 500)
      setCurrentColor('#FFFFFFF')
    }
    
  return (
    
      <div className= 'fixed flex flex-col justify-center place-items-center inset-0 z-50 bg-[#4945c12f] backdrop-blur-sm'>
          <img
            className='-mb-10  lg:ml-3 w-24 h-24  rounded-full shadow-xl border-white border-[5px] '
            width={63}
            height={23}
            src={ carte?.provider === '0HFR' ? LogoPCS : LogoTranscash}
            alt="Logo carte"
          />
   
        <div
          className={classNames('rounded-xl w-[377px] lg:w-[360px] object-center bg-cover bg-no-repeat ')}
            style={{ backgroundImage: `url(${imageBgRecharge})` }}

        >
          <div className=" p-4  justify-center flex flex-col text-center">
            <div className="font-bold text-[20px] text-[#1D3A70] mt-8">Recharge réussie</div>
         
            <div className='flex justify-between   border-b h-16 pb-4 items-end'> 
                <div className="text-[14px] font-normal text-[#6B7280] ">Code recharge</div>
                {/* <div className='flex flex-col items-end gap-1'> */}
                  <div className="text-[14px] font-bold text-[#1D3A70] flex items-center gap-2">
                    {voucher} 
                  {isCopie ? <span className='text-[#AEB6FB] w-7 text-xs'> copié</span>
                    :
                    <svg onClick={()=>handleCopy(voucher || '')} 
                        className={`cursor-pointer w-7  transition-colors duration-300  ${isCopie ? ' text-[#422EAE]' : 'text-[#5754E5]'}`}
                        width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5563 11.2183C11.514 12.2606 9.82411 12.2606 8.78171 11.2183C7.73943 10.1759 7.73943 8.486 8.78171 7.44364L11.1409 5.0845C12.1357 4.08961 13.7206 4.04433 14.7692 4.94866M14.4437 1.78175C15.486 0.739417 17.1759 0.739417 18.2183 1.78175C19.2606 2.82408 19.2606 4.51403 18.2183 5.55636L15.8591 7.9155C14.8643 8.9104 13.2794 8.9557 12.2308 8.0513" 
                        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8.4999 1C5.21257 1 3.56889 1 2.46256 1.9079C2.25998 2.07414 2.07423 2.25989 1.90798 2.46247C1.00007 3.56879 1.00006 5.21247 1.00002 8.4998L1 10.9999C0.99996 14.7712 0.999951 16.6568 2.17152 17.8284C3.3431 19 5.22873 19 9 19H11.4999C14.7874 19 16.4311 19 17.5375 18.092C17.74 17.9258 17.9257 17.7401 18.092 17.5376C18.9999 16.4312 18.9999 14.7875 18.9999 11.5" 
                        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  }
                  </div>
                    
                  
                {/* </div> */}
                
            </div>
            <div className='flex justify-between   border-b h-14 items-center'> 
                <div className="text-[14px] font-normal text-[#6B7280] ">Type de carte</div>
                <div className="text-[14px] font-bold text-[#1D3A70] ">
                {carte?.provider==='0HFR' ? ' PCS' :  ' TransCash'}

                 
                  </div>
            </div>
            <div className='flex justify-between  border-b h-14 items-center'> 
                <div className="text-[14px] font-normal text-[#6B7280] ">Montant à envoyer</div>
                <div className="text-[14px] font-bold text-[#1D3A70] ">{carte?.sendValue} EUR</div>
            </div>
            
            <div className='flex justify-between  border-b h-14 items-center'> 
                <div className="text-[14px] font-normal text-[#6B7280] ">Montant à recevoir</div>
                <div className="text-[14px] font-bold text-[#1D3A70] ">{carte?.receiveValue} EUR</div>
            </div>
            <div className='flex justify-between  border-b h-14 items-center'> 
                <div className="text-[14px] font-normal text-[#6B7280] ">Frais</div>
                <div className="text-[14px] font-bold text-[#1D3A70] ">{carte?.fees} EUR</div>
            </div>
            

            <div className='flex justify-between  border-b h-14 items-center'> 
                <div className="text-[14px] font-normal text-[#6B7280] ">Montant payé</div>
                <div className="text-[14px] font-bold text-[#1D3A70] ">{carte?.totalWithFee} EUR</div>
            </div>
              <button
                className="text-white text-[14px] font-semibold bg-[#4743C9] mt-5 p-4 rounded-xl"
                onClick={handleClick}
              >
                Mes recharges
              </button>
             
          </div>
        </div>
      </div>

    
  )
}

export default SuccessPaymentCarteModal
